import React from "react";
import { starAdvise } from "@utils/defaultImages";
import useMediaQueryHook from "@hooks/useMediaQueryHook";

const AdviseMeButton = ({
  t,
  setOpen,
  isAdviceLoading,
  countdown,
  width = "100%",
}) => {
    const {isMobile} = useMediaQueryHook()
  return (
    <button
      className={`py-3 mt-3 flex items-center justify-center rounded-[22px] min-h-[68px] text-white font-[Lato] text-[16px] xl:text-[20px] font-[600] ${isAdviceLoading && "opacity-70"}`}
      style={{
        background: "linear-gradient(180deg, #A7E8FF 0%, #4CDBFF 100%)",
        width: isMobile ? "100%" : width,
        margin: isMobile && " 0 20px",
      }}
      disabled={isAdviceLoading}
      onClick={() => setOpen(true)}
    >
      {isAdviceLoading ? (
        `(${countdown}s)`
      ) : (
        <>
           {t("Give Me Your Expert Advise")}
           <img src={starAdvise} alt="Star" className="mr-2 w-6 h-6 xl:w-11 xl:h-11" />
        </>
      )}
    </button>
  );
};

export default AdviseMeButton;
